import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';
import {getFormData, inputChangedHandler, prepareFormData, updateObject, validateForm} from "../../shared/utility";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green, red} from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import {IconButton} from "@material-ui/core";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import EmailIcon from "@material-ui/icons/Email";
import * as actions from "../../store/actions";
import {connect} from "react-redux";

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    messageText: {
        marginBottom: theme.spacing(2),
        color: red[500],
        fontSize: '16px'
    }
}));


let formData = {
    controls: {
        email: {
            label: 'Email Address',
            value: '',
            validation: {
                presence: true,
                email: {message: 'is not a valid'}
            },
            valid: false,
            touched: false,
        },
        code: {
            label: 'Verification Code',
            value: '',
            validation: {
                length: {is: 6, allowEmpty: false, message: 'Verification code is incorrect'},
            },
            valid: false,
            touched: false,
        },
        password: {
            label: 'New Password',
            value: '',
            validation: {
                length: {minimum: 8, allowEmpty: false},
            },
            valid: false,
            touched: false,
            showPassword: false,
        },
        repassword: {
            placeholder: 'Repeat New Password',
            value: '',
            validation: {
                equality: {attribute: "password", message: 'Passwords do not match'}
            },
            valid: false,
            touched: false,
            showPassword: false,
        }
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null
}


const ResetPassword = (props) => {

    const classes = useStyles();
    const [formState, setFormState] = useState(formData);
    useEffect(() => {
        const state = {email: props.email}
        formData = prepareFormData(formState, state);
        setFormState(formData);
    }, [props.email])

    const [verificationState, setVerificationState] = useState({
        show: false,
        loading: false,
        message: ''
    });

    const history = useHistory();


    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = getFormData(formState)
            props.onResetPassword(data.email, data.code, data.password, (error, redirect) => {
                let message = String(error && error.message ? error.message : error);
                if (message.indexOf('You\'ve reached the maximum number of attempts') > -1) { // . Please try to login again.
                    setVerificationState({
                        ...verificationState,
                        show: true,
                        message: 'You\'ve reached the maximum number of attempts.'
                    });
                    props.authStop();
                } else if (message.indexOf('The verification code has expired') > -1) { // . Please try to login again.
                    setVerificationState({
                        ...verificationState,
                        show: true,
                        message: 'The verification code has expired.'
                    });
                    props.authStop();
                } else if (error) {
                    props.authError(error);
                }

                if (redirect) {
                    history.push(redirect)
                }

            });
        }
    }

    const onResendVerificationCode = async (event) => {

        if (!validateForm(formState, setFormState, ['email'])) {
            return;
        }

        const email = formState.controls.email.value;
        setVerificationState({
            ...verificationState,
            loading: true
        });

        props.onForgotPassword(email, (err, redirect) => {
            setVerificationState({
                ...verificationState,
                loading: false,
                show: false
            });
            formState.controls.code.value = '';
            setFormState(formState);

            if (err) {
                console.error(err);
                return;
            }
        })
    }


    const passShowedHandler = (key) => {
        const updatedState = updateObject(formState.controls);
        updatedState[key].showPassword = !updatedState[key].showPassword
        setFormState(updateObject(formState, {controls: updatedState}));
    }

    const codeField = formState.controls.code;
    const emailField = formState.controls.email;
    const passwordField = formState.controls.password;
    const repasswordField = formState.controls.repassword;


    const resendCodeBox = verificationState.show ? (<div className={classes.wrapper}>
        <div className={classes.messageText}>{verificationState.message}</div>
        <Button type={"button"} fullWidth color={"primary"} size={"large"} className="LoginButton"
                disabled={props.loading} onClick={onResendVerificationCode}>Send a new verification code</Button>
        {props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
    </div>) : null;

    return (
        <React.Fragment>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div>
                    <TextField
                        name={emailField.key}
                        value={emailField.value}
                        type='email'
                        placeholder={emailField.label}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, emailField.key)}
                        helperText={emailField.helperText}
                        error={!emailField.valid && emailField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon/>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div>
                    <TextField
                        name={codeField.label}
                        value={codeField.value}
                        type={'input'}
                        placeholder={codeField.label}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, codeField.key)}
                        helperText={codeField.helperText}
                        error={!codeField.valid && codeField.touched}
                    />

                </div>
                <div>
                    <TextField
                        name={passwordField.key}
                        value={passwordField.value}
                        type={passwordField.showPassword ? 'input' : 'password'}
                        placeholder={passwordField.label}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, passwordField.key)}
                        helperText={passwordField.helperText}
                        error={!passwordField.valid && passwordField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon/>
                                </InputAdornment>
                            ),
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    onClick={passShowedHandler.bind(this, 'password')}
                                    edge="end"
                                >
                                    {passwordField.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>)
                        }}
                    />

                </div>
                <div>
                    <TextField
                        name={repasswordField.key}
                        value={repasswordField.value}
                        type={repasswordField.showPassword ? 'input' : 'password'}
                        placeholder={repasswordField.placeholder}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, repasswordField.key)}
                        helperText={repasswordField.helperText}
                        error={!repasswordField.valid && repasswordField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon/>
                                </InputAdornment>
                            ),
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    onClick={passShowedHandler.bind(this, 'repassword')}
                                    edge="end"
                                >
                                    {repasswordField.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>)
                        }}
                    />

                </div>

                {props.error &&
                <div>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }
                {resendCodeBox}
                <div className={classes.wrapper}>
                    <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"}
                            className="LoginButton"
                            disabled={props.loading || verificationState.loading}> Set New
                        Password</Button>
                    {props.loading && !verificationState.loading &&
                    <CircularProgress size={24} className={classes.buttonProgress}/>}
                </div>
            </form>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        resetPassword: state.auth.resetPassword,
        loading: state.auth.loading,
        error: state.auth.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onForgotPassword: (email, onRedirect) => dispatch(actions.forgotPassword(email, onRedirect)),
        onResetPassword: (email, code, password, cb) => dispatch(actions.resetPassword(email, code, password, cb)),
        authError: (message) => dispatch(actions.authError(message)),
        authStop: () => dispatch(actions.authStop())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

